export default __webpack_public_path__ + "static/media/closeIcon.22c6cbf7.svg";